import { graphql, useStaticQuery } from "gatsby";

const useImage: any = (srcName: string) => {
    const data = useStaticQuery(graphql`
        query {
            allImageSharp {
                nodes {
                    fluid {
                        ...GatsbyImageSharpFluid_withWebp
                        originalName
                    }
                }
            }
        }
    `);

    // console.log(data.allImageSharp.nodes[0].fluid.originalName);
    return data.allImageSharp.nodes.filter(
        img => img.fluid.originalName === srcName
    );
};

export default useImage;
